import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useUploadImage } from "../../Board/hooks/useUploadImage.ts";
import { UPLOAD_MAX_IMAGE_SIZE } from "../../constants.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import { useModelUuid } from "./useModelUuid.ts";

export const useAddImageOnModel = ({
  onUploaded,
}: {
  onUploaded?: () => void;
}) => {
  const modelUuid = useModelUuid();

  const {
    mutate: upload,
    isLoading,
    progress,
  } = useUploadImage({
    onSuccess: (imageUuid) => {
      linkToModel({
        image_uuid: imageUuid,
        reference_uuid: modelUuid,
      });
    },
    describeImage: true,
    maxSize: UPLOAD_MAX_IMAGE_SIZE,
  });

  const workspaceUuid = useWorkspaceUuid();

  const {
    mutation: { mutate: linkToModel, isLoading: isModelLinkingLoading },
  } = useAppMutation({
    path: "references/add-training-image",
    invalidate: [
      `workspaces/${workspaceUuid}/references`,
      `references/${modelUuid}`,
    ],
    onCacheUpdated: () => {
      onUploaded?.();
    },
  });

  return {
    mutate: ({ image }: { image: Blob }) => {
      upload({ image });
    },
    isLoading: isLoading || isModelLinkingLoading,
    progress,
  };
};
